import React from "react";

const GroupLabel = ({ label, primary, title }) => {
  return (
    <span
      title={title || label}
      className={`px-2 py-1.5 border rounded-md border-primary-200 text-xs truncate ${
        primary ? "min-w-0" : "shrink-0 max-w-[50%]"
      }`}
    >
      {label}
    </span>
  );
};

const GroupLabels = ({ groups }) => {
  return (
    <div className="flex gap-1">
      <GroupLabel label={groups[0]?.groupName} primary />
      {groups.length > 2 ? (
        <GroupLabel
          title={groups
            .slice(1)
            .map((group) => group.groupName)
            .join(", ")}
          label={`+${groups.length - 1} more`}
        />
      ) : (
        groups.length > 1 && <GroupLabel label={groups[1]?.groupName} />
      )}
    </div>
  );
};

export default GroupLabels;
